import React, { useEffect, useState } from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ApiServices from 'services/ApiServices';
import {PictureAsPdf, Send} from '@material-ui/icons/';
import Form from 'components/Form/FormTwoColumns';
import {useStyles} from './style';
import { Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { functions } from "constants/index";
import MostrarPDFModal from 'components/PdfModal'
import BotonPersonalizado from 'components/BotonNormal'
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import DialogLoadingMessage from 'components/LoadingMessage/index'

const  FiltrosParaGenerarReporteDetalladoAgrupadosPorDepartamentoYGenero= (props)=> {
    const classes = useStyles(),
    [base64, setBase64] = useState(''),
    [abrirMostrarPDFModal, setAbrirMostrarPDFModal] = useState(false),
    [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});

    let description = [
        {name: "Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "Datos requeridos (*)."}
    ]
    let arrayTipoReporte=[
        {id: 1, name:"1. DETALLADO"},
        {id: 2, name:"2. MUNICIPIOS"},
    ]
    const obtenerDepartamentos =async ()=>{
        setLoadingMessage({loading: true, title:'Cargando departamentos ...'})
        let newElements= Object. assign({}, elements); 
        if(props.catalogos?.departamentos?.length >0){
            newElements.departamento.list= props.catalogos?.departamentos
        }else{
            try{
                let response = await ApiServices.departamentos.listRegisterCriteria();
                newElements.departamento.list=[];
                if(response.error){
                    showMessagePersonalizedPosition('error', '¡Oops! ' , response.error.message, 'center')                    
                }else {  
                    var datos = response.data
                    Object.keys(datos).forEach((element, key, _array) =>{
                        if(datos[element].id === "23" || datos[element].id === "24" || datos[element].id === "25"){
                        }else{
                            newElements.departamento.list.push({
                                id: datos[element].id,
                                name: datos[element].name,
                            });
                        }
                    }) 
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS(newElements.departamento.list)                                        
                    elements.municipio.value = null
                } 
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }                    
                newElements.departamento.list=[];
            }      
            setElements(newElements);
        }
        setLoadingMessage({loading: false, title:''})
    };
    //cargamos los municipios en base al departamento seleccionado        
    const obtenerMunicipios =async (event)=>{
        setLoadingMessage({loading: true, title:'Cargando municipios ...'})
        let newElements= Object. assign({}, elements); 
        elements.municipio.value = null
        let idDepartamento = event.target.value
     
        try{
            ApiServices.municipios.searchCriteria.clear();
            ApiServices.municipios.searchCriteria.setOperator("and");
            ApiServices.municipios.searchCriteria.addEquals("departamentoId",idDepartamento);
            ApiServices.municipios.setIsPublic(true);
            let response =await ApiServices.municipios.listRegisterCriteria();
            if(response.error){
                showMessagePersonalizedPosition('error', '¡Oops! ' , response.error.message, 'center')                    
                newElements.municipio.list=[];
            }else {                
                newElements.municipio.list=response.data;
            }
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }            
            newElements.municipio.list=[];
        }
        setElements(newElements);
        setLoadingMessage({loading: false, title:''})
    };
    const [elements,setElements] = useState({
        departamento: {
            idelement: "departamento", value: null, label: "Departamento *", pattern:"^[0-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerMunicipios,
        },
        municipio: {
            idelement: "municipio", value: null, label: "Municipio *", pattern:"^[0-9][0-9]*$", validators: ['required'], 
            errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [], 
        },
        fechaInicial: { 
            idelement: "fechaInicial", value: null , label: "Fecha Inicial", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['requireds'], 
            errorMessages:['Ingrese fecha limite'], isError:false, elementType:'date' 
        },
        fechaLimite: { 
            idelement: "fechaLimite", value: null , label: "Fecha Limite", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['requireds'], 
            errorMessages:['Ingrese fecha limite'], isError:false, elementType:'date' 
        },
    });

    const CerrarMostrarPDFModal = () => {
        setAbrirMostrarPDFModal(false)
    }

    const GenerarReporte = async () => {
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement( elements, setElements );
        if(elements.departamento.value === null) elements.municipio.list=[];
        if(allGood){
            setLoadingMessage({loading: true, title:'Generando reporte. Espere un momento por favor! ...'})
            var saveData = {}
            if(elements.fechaLimite.value === ''){
                saveData = {
                    departamentos: elements.departamento.value.id,
                    municipios: elements.municipio.value.id,
                    tipoReporte: (props.tipoReporte === 0) ? 1:2
                };
            }else{
                saveData = {
                    departamentos: elements.departamento.value.id,
                    municipios: elements.municipio.value.id,
                    fechaInicial: elements.fechaInicial.value,
                    fechaLimite: elements.fechaLimite.value,
                    tipoReporte: (props.tipoReporte === 0) ? 1:2
                };
            }
            try {
                let response = await ApiServices.reportesEstadisticos.reporteDetalladoAgrupadoPorDepartamentoYGenero(saveData)
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message, 'center')
                }
                else{                    
                    DescargarPDF(response.data)
                    showMessagePersonalizedPosition('success', '¡BIEN!', "Reporte generado y descargado correctamente.", 'center')
                }
            } catch (exception) {
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }  
            setLoadingMessage({loading: false, title:''})
        }        
    };

    const DescargarPDF = (base64) => {
        functions.downloadPDFFromStringBase64(base64, props.titulo+'.pdf');
    }
    useEffect(() => {
        obtenerDepartamentos()
    },[])
    return (
        <div>            
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <br/>
            <Container maxWidth="lg">        
                <Grid container >
                    <div className={classes.colorComponente}>
                        <Grid item xs={12}>
                            <div className={classes.centerTitle}><Divider /> <strong>Complete los filtros para generar el reporte</strong> <Divider /></div>
                        </Grid >
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                            <Form   elements= {elements}/>
                        </Grid>
                        {
                            description && (
                                <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                                    <List>
                                        {
                                            description.map((text, index) => {
                                                return (
                                                    <ListItem>
                                                        <ListItemIcon> <Send color="primary"/></ListItemIcon>
                                                        <ListItemText style={{color: 'black'}} primary={text.name}/>
                                                    </ListItem>
                                                )
                                            })                                
                                        }
                                    </List>
                                </Grid>
                            )
                        } 
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                            <BotonPersonalizado title={"Generar y mostrar reporte en PDF"}  botonPersonalizado={true} function={GenerarReporte} icon={<PictureAsPdf/>} /> 
                        </Grid>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                </Grid>
            <MostrarPDFModal open={abrirMostrarPDFModal} handleClose={CerrarMostrarPDFModal} title={props.titulo} base64={base64} DescargarPDF={DescargarPDF}/>
            </Container>
        </div>
    );   
}
export default connect(mapStateToProps, mapDispatchToProps)(FiltrosParaGenerarReporteDetalladoAgrupadosPorDepartamentoYGenero);